import { getAppPromptHost } from '@/utils/appPromptHost'

export default {
  install(Vue) {
    Vue.prototype.$confirm = function confirm(message, options) {
      const host = getAppPromptHost()
      if (!host) return Promise.resolve(false)
      return host.confirm(message, options)
    }
    Vue.prototype.$appAlert = function appAlert(message, options) {
      const host = getAppPromptHost()
      if (!host) return Promise.resolve()
      return host.alert(message, options)
    }
    Vue.prototype.$prompt = function prompt(message, options) {
      const host = getAppPromptHost()
      if (!host) return Promise.resolve(null)
      return host.prompt(message, options)
    }
  },
}
